import tokenApiService from '@/request/token/token.api.service';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTradeStore } from '../store';
import { useAppStore } from '@/store';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';

export const useInitTokenInfo = () => {
  const { address } = useParams();
  const {
    setChainTokenAddressMap,
    chainInfo: { path },
  } = useAppStore();
  const { setPriceChg, setTokenRealtimePrice, setTokenInfo } = useTradeStore();
  const { subscribe } = useAppEventBusContext();

  const fetchTokenInfo = async () => {
    try {
      if (!address) return;
      setChainTokenAddressMap(path, address);
      const res = await tokenApiService.getTokenInfo({ address });
      if (res.code == 0) {
        setTokenInfo(res.data);
        setPriceChg(res.data.priceChange);
        setTokenRealtimePrice(res.data.price.toString());
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTokenInfo();
  }, [address]);

  useEffect(() => {
    const unsubscribe = subscribe(SubscribeEvent.Update_Token_Info, () => {
      fetchTokenInfo();
    });
    return () => unsubscribe();
  }, []);
};
